module.exports = __webpack_public_path__ + "img/googlesatelitemap.81b98d0e.jpg";